export default __webpack_public_path__ + "static/4-2_Lense_Specifications-2d2cd0fb9f3cf3489dc66d9f360f9058.png";